module.exports = {
          srcSet: __webpack_public_path__ + "949d6ec23a0cf75723b57b2f2bb6d8db-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "949d6ec23a0cf75723b57b2f2bb6d8db-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "949d6ec23a0cf75723b57b2f2bb6d8db-60.png",
          toString:function(){return __webpack_public_path__ + "949d6ec23a0cf75723b57b2f2bb6d8db-60.png"},
          
          width: 60,
          height: 60
        }